function initialiseQuickBuy(root = document) {
  root.querySelectorAll('[data-koketa-quick-buy]:not([data-koketa-ready])').forEach((quickBuy) => {
    quickBuy.dataset.koketaReady = 'true';
    const select = quickBuy.querySelector('[data-koketa-variant-select]');
    const variantInput = quickBuy.querySelector('input[name="id"]');
    const button = quickBuy.querySelector('[ref="addToCartButton"]');
    if (!select || !variantInput || !button) return;

    const syncVariant = () => {
      const option = select.options[select.selectedIndex];
      const available = option?.dataset.available === 'true';
      variantInput.value = select.value;
      variantInput.disabled = !available;
      button.disabled = !available;
    };

    select.addEventListener('change', syncVariant);
    syncVariant();
  });
}

initialiseQuickBuy();
document.addEventListener('shopify:section:load', (event) => initialiseQuickBuy(event.target));

